import { useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CancelIcon2, RoundedTickIcon } from "../../icons/Icon";
import Button from "../Dealers/Button";
import { useToast } from "../Toaster/Toaster";
import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";

const CancelReasonModal = ({
  onClose,
  onSubmit,
  mode,
  type = "dispatch",
  uniqueWarehouses = [],
  heading = "Request for Cancel",
  subHeading,
  loading,
  minLength = 20,
  activeType,
}) => {
  const { show } = useToast();
  const [reason, setReason] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState({
    label: "Select",
    value: "Select",
  });

  const handleClick = () => {
    if (loading) return;

    if (isorderWise) {
      if (reason.trim().length < minLength) {
        show(`The reason must be at least ${minLength} characters!`, "warning");
        return;
      }
      if (selectedWarehouse.label === "Select" && type === "order") {
        show("Select a warehouse to cancel the order!", "warning");
        return;
      }

      onSubmit(reason, selectedWarehouse.value);
    } else {
      onSubmit(reason, selectedWarehouse.value);
    }
  };

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  const isorderWise = activeType === "Order Wise";

  return (
    <div
      className={styles.req_for_cancel}
      style={mode ? { backgroundColor: "#232529" } : {}}
    >
      <p style={mode ? { color: "#FFFFFF" } : {}}>{heading}</p>

      {subHeading && (
        <p
          style={{
            fontSize: 12,
            marginTop: -4,
            color: mode ? "#9CA3AF" : "#6B7280",
          }}
        >
          {subHeading}
        </p>
      )}

      {type === "order" && (
        <div className={styles.column}>
          <p style={mode ? { color: "#FFFFFF" } : {}}>
            Select warehouse to cancel
          </p>
          <VerticalDropDown2
            height={"37px"}
            fontSize={"12px"}
            dropDownText={"Select"}
            value={selectedWarehouse}
            options={uniqueWarehouses.map((w) => ({
              label: w.label,
              value: w.value,
            }))}
            onchange={(option) => {
              setSelectedWarehouse(option);
            }}
            disabled={loading}
          />
        </div>
      )}

      {isorderWise && (
        <>
          <div className={styles.column}>
            <p style={mode ? { color: "#FFFFFF" } : {}}>
              Enter the reason why you need to cancel this Voucher
            </p>
            <textarea
              placeholder={`*minimum ${minLength} characters`}
              required
              rows="4"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={loading}
              className={`${styles.textarea} ${mode ? styles.textarea_dark : ""}`}
            ></textarea>
          </div>
        </>
      )}

      <div className={styles.req_for_cancel_btns}>
        <Button
          buttonIcon={<CancelIcon2 />}
          buttonText={isorderWise ? "Cancel" : "No"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={handleClose}
          disabled={loading}
        />
        <Button
          buttonIcon={<RoundedTickIcon />}
          buttonText={isorderWise ? "Submit" : "Yes, Cancel"}
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={handleClick}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default CancelReasonModal;
